import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "12px",
	height: "21px",
	viewBox: "0 0 12 21",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "caret-down" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "caret-down",
				transform: "translate(6.500000, 10.500000) rotate(-270.000000) translate(-6.500000, -10.500000) translate(-4.000000, 4.000000)",
				fill: "#000000",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group",
					transform: "translate(10.500000, 6.266000) rotate(-90.000000) translate(-10.500000, -6.266000) translate(4.500000, -4.234000)",
					children: /* @__PURE__ */ _jsx("polygon", {
						id: "Path",
						points: "10.385 20.772 0 10.386 10.386 0 11.265 0.879 1.758 10.386 11.264 19.893"
					})
				})
			})
		})
	]
});
export default SvgCaretLeft;
